import {
	InviteAdminDialog,
	PendingAdminInvitations,
	UsersTable,
} from "@nwga/features/admin/ui";
import { useTRPC } from "@nwga/features/client";
import { Skeleton } from "@nwga/ui/components/skeleton";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/users")({
	component: AdminUsersPage,
});

function AdminUsersPage() {
	const trpc = useTRPC();
	const session = useQuery(trpc.session.queryOptions());

	return (
		<div className="flex flex-col gap-6">
			<div className="flex flex-wrap items-start justify-between gap-4">
				<div>
					<h1 className="font-semibold text-2xl tracking-tight">People</h1>
					<p className="mt-1 text-muted-foreground text-sm">
						Accounts on the platform, and what each one is allowed to do.
					</p>
				</div>
				<InviteAdminDialog />
			</div>

			<PendingAdminInvitations />

			{/* The table needs to know who you are so it can refuse to let you
          change your own role — so it waits rather than rendering without it. */}
			{session.data?.user == null ? (
				<Skeleton className="h-64 w-full" />
			) : (
				<UsersTable currentUserId={session.data.user.id} />
			)}
		</div>
	);
}
